module.exports = __webpack_public_path__ + "static/media/bodycare.2d169929.svg";